import SelectField from '../Forms/Input/SelectField';
import SimpleSearchSelect from '../Forms/Input/SimpleSearchSelect';
import { BusinessConfigurationForm } from '../../types/business/BusinessTypes';

interface Option {
  id: number;
  name: string;
}

interface Props {
  form: BusinessConfigurationForm;
  errors: Record<string, string>;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onEconomicActivitySelect: (option: Option) => void;
  onEconomicActivitySearch: (text: string) => void;
  taxpayerCategoryOptions: Option[];
  economicActivityOptions: Option[];
}

const FiscalConfigSection = ({
  form,
  errors,
  onChange,
  onEconomicActivitySelect,
  onEconomicActivitySearch,
  taxpayerCategoryOptions,
  economicActivityOptions,
}: Props) => (
  <div className="p-0">
    <div className="mb-6">
      <h2 className="text-gray-800 text-lg font-semibold dark:text-white">
        Configuración Fiscal
      </h2>
      <p className="text-gray-500 dark:text-gray-400 text-sm">
        Seleccione la categoría y actividad económica de su empresa.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {/* Categoría Contribuyente ocupa 1 columna */}
      <div className="lg:col-span-1">
        <SelectField
          label="Categoría Contribuyente"
          name="taxpayerCategoryId"
          value={form.taxpayerCategoryId ?? ''}
          onChange={onChange}
          options={taxpayerCategoryOptions.map((opt) => ({
            value: opt.id,
            label: opt.name,
          }))}
          iconKey="list"
          error={errors.taxpayerCategoryId}
          required
        />
      </div>

      {/* Actividad Económica ocupa 2 columnas en pantallas grandes */}
      <div className="lg:col-span-2">
        <SimpleSearchSelect
          name="economicActivityId"
          label="Actividad Económica"
          selectedValue={form.economicActivityId}
          onSelect={onEconomicActivitySelect}
          onSearch={onEconomicActivitySearch}
          options={economicActivityOptions}
          iconKey="listOrdered"
          error={errors.economicActivityId}
          required
        />
      </div>
    </div>
  </div>
);

export default FiscalConfigSection;
